import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useMenuNav } from '../../hooks/use_menu_nav.js';
import { mergeProps } from '../../utils/react.js';
import { Box } from '../Box/Box.js';
import { List } from '../List/List.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var Menu = /*#__PURE__*/React.forwardRef(function MenuList(props, ref) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var menuProps = useMenuNav({
    children: children,
    role: "menu"
  });
  return /*#__PURE__*/jsx(Box, _objectSpread(_objectSpread({}, mergeProps(_objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  }), menuProps)), {}, {
    as: List
  }));
});
Menu.propTypes = {
  "children": _PropTypes.node
};
Menu.displayName = "Menu";

export { Menu };
